import styled from 'styled-components';
import is from 'styled-is';

import { Z_INDEX } from 'modules/journey/stop-status-log/z-index';

export default styled.div`
  border-top: 2px solid var(--grey200);
  border-left: 2px solid var(--grey200);
  background: var(--grey100);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${Z_INDEX.VOID};

  ${is('clickable')`
    border-top: 2px solid var(--grey100);
    border-left: 2px solid var(--grey100);
    background: #fff;
  `}
`;
